import AiDocument from './AiDocumentDetails'

export default AiDocument
